export const VEHICLE_SOURCES = [["stock", "Véhicule en stock"], ["fabrication", "Véhicule à fabriquer"]];

export const VehicleSourcePicker = ({ value, onChange, t }) => (
  <div data-testid="vehicle-source-block">
    <div className="text-xs text-muted-foreground">
      {t("Origine du véhicule")} <span className="text-destructive">*</span>
    </div>
    <div className="flex flex-wrap gap-2 mt-1">
      {VEHICLE_SOURCES.map(([v, l]) => (
        <label key={v} data-testid={`vehicle-source-${v}`}
          className={`flex items-center gap-2 text-sm rounded-md border px-3 py-1.5 cursor-pointer transition-colors ${value === v ? "border-primary bg-primary/10 font-medium" : "border-border hover:bg-muted"}`}>
          <input type="radio" name="vehicle-source" checked={value === v} onChange={() => onChange(v)} className="accent-[#9E7B41]" />
          {t(l)}
        </label>
      ))}
    </div>
    {!value && <div className="text-[11px] text-destructive mt-1" data-testid="vehicle-source-required">{t("Obligatoire avant la signature")}</div>}
  </div>
);


export const PtacPicker = ({ values, value, onChange, t }) => (
  <div className="pb-3 mb-1 border-b border-border flex flex-wrap items-center gap-2" data-testid="ptac-block">
    <span className="text-sm">{t("F2 (Poids total autorisé en charge)")}</span>
    <select value={value || ""} onChange={(e) => onChange(Number(e.target.value))} data-testid="ptac-select"
      className="h-8 rounded-md border border-border bg-background px-2 text-sm font-mono">
      {values.map((v) => <option key={v} value={v}>{v} kg</option>)}
    </select>
    <span className="text-xs text-muted-foreground">{t("Inclus")}</span>
  </div>
);
